const namespaces = ['common', 'defaultLayout']

export default namespaces
